import { http } from "../core";
import { URL } from "./_url";
import { StatusCode } from "../constant";

const apiFetchFooterDetails = async (communityId: string, mode: string) => {
  const response = await http.get(URL.FETCH_FOOTER(communityId, mode));
  if (response && response.status >= StatusCode.BADREQUEST) {
    throw new Error(response.status);
  }
  return response || null;
};

export { apiFetchFooterDetails };
